/* eslint-disable jsx-a11y/anchor-is-valid */
import { PageTitle } from '../../_metronic/layout/core'
import { useIntl } from 'react-intl'
import { Link, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { Loader } from '../../components/Loader'
import { TraidList } from '../../components/PrsRunDetail/TraidList'
import TraitDetailModal from '../../components/PrsRunDetail/TraitDetailModal'
import prsService from '../../service/prs'
import { PRSNotCompleted } from '../../components/PrsRunDetail/PRSNotCompleted'
import { ClientInformation } from '../../components/PrsRunDetail/ClientInformation'
import { PrsInformation } from '../../components/PrsRunDetail/PrsInformation'
import { ReportButtons } from '../../components/PrsRunDetail/ReportButtons'
import Swal from 'sweetalert2'
import ChatBox from '../../components/PrsRunDetail/ChatBox'

const PrsRunDetailPage = () => {
  const intl = useIntl()
  const { id } = useParams()
  const [runData, setRunData] = useState({})
  const [selectedTraidList, setSelectedTraidList] = useState([])
  const [runTraits, setRunTraits] = useState([])
  const [availableTraits, setAvailableTraits] = useState([])
  const [selectedPgsData, setSelectedPgsData] = useState(null)
  const [requestedPgs, setRequestedPgs] = useState({})
  const [currentTraitIndex, setCurrentTraitIndex] = useState(0)
  const [isLoading, setIsLoading] = useState(true)
  const [selectedPresetChangeLoading, setSelectedPresetChangeLoading] = useState(false)
  
  // Modal state management
  const [modalView, setModalView] = useState(null) // null, 'traitList', or 'traitDetail'
  
  const handleTraitClick = () => {
    setModalView('traitDetail')  // Sadece görünüm değişsin, data zaten setSelectedPgsData'da geliyor
  }
  
  const [selectedPreset, setSelectedPreset] = useState({
    id: 0,
    name: '',
  })
  const [presets, setPresets] = useState([])
  const [error, setError] = useState(0)
  const getPresets = async () => {
    try {
      const res = await prsService.getPresets()
      setPresets(res.data)
    } catch (error) {
      console.log(error)
    }
  }
  const getData = async () => {
    setSelectedPresetChangeLoading(true)

    try {
      const getRunDetail = await prsService.getPrsDetail(id)
      if (getRunDetail.status === 200) {
        setRunData(getRunDetail.data)
        if (getRunDetail.data.status !== 'Completed') {
          setIsLoading(false)
          return
        }
        const baseUrl = `https://${getRunDetail.data.onNode
          }.node.gennext.bio/api/v0/prs/runs/${id}?${selectedPreset?.id !== 0 ? `presetid=${selectedPreset?.id}` : ''}`
        const getTraits = await prsService.getTraits(baseUrl)
        if (getTraits.status === 200) {
          getPresets()
          setRunTraits(getTraits.data)
          setIsLoading(false)
        }
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Something went wrong while fetching the data.',
        showCloseButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Reload Page',
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.reload()
        }
      })
      setError(1)
      setIsLoading(false)
    }
    finally {
      setSelectedPresetChangeLoading(false)
    }
  }


  const getDataByPresetId = async () => {
    setSelectedPresetChangeLoading(true)
    try {
      const baseUrl = `https://${runData.onNode
        }.node.gennext.bio/api/v0/prs/runs/${id}?${selectedPreset?.id !== 0 ? `presetid=${selectedPreset?.id}` : ''
        } `
      const getTraits = await prsService.getTraits(baseUrl)
      if (getTraits.status === 200) {
        getPresets()
        setRunTraits(getTraits.data)
        setIsLoading(false)
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Something went wrong while fetching the data.',
        showCloseButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Reload Page',
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.reload()
        }
      })
      setError(1)
      setIsLoading(false)
    }
    finally {
      setSelectedPresetChangeLoading(false)
    }
  }
  useEffect(() => {
    getData()
  }, [])
  
  useEffect(() => {
    if (selectedPreset.id !== 0) {
      getDataByPresetId()
      // Only open trait list modal when preset is selected through the search button, not report button
      if (selectedPreset.fromSearch) {
        setModalView('traitList')
      }
    }
  }, [selectedPreset])

  const getAvailableTraits = async (row) => {
    Swal.fire({
      title: 'Loading',
      html: 'Please wait...',
      allowOutsideClick: false,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading()
      },
    })
 
    const baseUrl = `https://${runData.onNode}.node.gennext.bio/api/v0/prs/runs/${id}/trait?trait_id=${row.id}&${selectedPreset?.id !== 0 ? `presetid=${selectedPreset?.id}` : ''
      }`
 
    const getTraitById = await prsService.getTraits(baseUrl)
    if (getTraitById.status === 200) {
      setAvailableTraits(getTraitById.data)
      if (getTraitById.data.length > 0) {
        await fetchPgsData(getTraitById.data[0], 0)
        Swal.close()
      }
    }
  }

  const fetchPgsData = async (pgsId, traitIndex) => {
    Swal.fire({
      title: 'Loading',
      html: 'Please wait...',
      allowOutsideClick: false,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading()
      },
    })
    if (requestedPgs[pgsId]) {
      setSelectedPgsData(requestedPgs[pgsId])
      setCurrentTraitIndex(traitIndex)
      Swal.close()
    } else { 
      const baseUrl = `https://${runData.onNode}.node.gennext.bio/api/v0/prs/runs/${id}/pgs?pgs_id=${pgsId}&${selectedPreset?.id !== 0 ? `presetid=${selectedPreset?.id}` : ''
        }`
 
      const getPgsData = await prsService.getTraits(baseUrl)
      if (getPgsData.status === 200) {
        setSelectedPgsData(getPgsData.data)
        setRequestedPgs((prev) => ({ ...prev, [pgsId]: getPgsData.data }))
        setCurrentTraitIndex(traitIndex)
        Swal.close()
      }
    }
  }

  const handleNext = async () => {
    const nextIndex = currentTraitIndex + 1
    if (nextIndex < availableTraits.length) {
      const nextPgsId = availableTraits[nextIndex]

      Swal.fire({
        title: 'Loading',
        html: 'Please wait...',
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading()
        },
      })

      if (requestedPgs[nextPgsId]) {
        setSelectedPgsData(requestedPgs[nextPgsId])
        setCurrentTraitIndex(nextIndex)
        Swal.close()
      } else {
        await fetchPgsData(nextPgsId, nextIndex)
        Swal.close()
      }
    }
  }

  const handlePrevious = async () => {
    const prevIndex = currentTraitIndex - 1
    if (prevIndex >= 0) {
      const prevPgsId = availableTraits[prevIndex]

      Swal.fire({
        title: 'Loading',
        html: 'Please wait...',
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading()
        },
      })

      if (requestedPgs[prevPgsId]) {
        setSelectedPgsData(requestedPgs[prevPgsId])
        setCurrentTraitIndex(prevIndex)
        Swal.close()
      } else {
        await fetchPgsData(prevPgsId, prevIndex)
        Swal.close()
      }
    }
  }
  
  const handleSearchPreset = (presetId) => {
    // Find the preset object from the presets array
    if (presetId === '0') {
      setSelectedPreset({ id: 0, name: '', fromSearch: true })
      return
    }
    
    const preset = presets.find((preset) => preset.id === presetId)
    if (preset) {
      setSelectedPreset({ ...preset, fromSearch: true })
    } else {
      console.warn("Preset not found for ID:", presetId)
    }
  }
  
  const handleReportPreset = (presetId) => {
    // Find the preset object from the presets array
    if (presetId === '0') {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please select a template.',
      })
      return
    }
    
    const preset = presets.find((preset) => preset.id === presetId)
    if (preset) {
      // Update selectedPreset without triggering modal
      setSelectedPreset({ ...preset, fromSearch: false })
      
      // Call getReport after a short delay to ensure state is updated
      setTimeout(() => {
        getReport(preset.id)
      }, 100)
    } else {
      console.warn("Preset not found for ID:", presetId)
    }
  }

  const getReport = async (presetId) => {
    if (!presetId) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please select a template.',
      })
      return
    }
    
    try {
      const language = await new Promise((resolve) => {
        Swal.fire({
          title: 'Select Report Language',
          html: `
            <button id="btn-tr" class="swal2-confirm btn btn-primary" style="margin: 0 10px;">TR</button>
            <button id="btn-en" class="swal2-cancel btn bg-brand text-white" style="margin: 0 10px;">EN</button>
          `,
          showCloseButton: true,
          showCancelButton: false,
          showConfirmButton: false,
          allowOutsideClick: true,
          customClass: {
            closeButton: 'shadow-none',
          },
          didOpen: () => {
            document.getElementById('btn-tr').addEventListener('click', () => resolve('TR'))
            document.getElementById('btn-en').addEventListener('click', () => resolve('EN'))
          },
          willClose: () => resolve(null),
        })
      })

      if (!language) return

      Swal.fire({
        title: 'Generating',
        html: 'Please wait...',
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading()
        },
      })

      const baseUrl = `https://${runData.onNode}.node.gennext.bio/api/v0/prs/runs/${id}/report?lang=${language}&presetid=${presetId}`
      const response = await prsService.getReport(baseUrl)

      const blob = new Blob([response.data], { type: 'application/pdf' })
      const url = window.URL.createObjectURL(blob)
      window.open(url, '_blank')
    } catch (error) {
      console.error('An error occurred:', error)
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Something went wrong while fetching the report.',
      })
    } finally {
      Swal.close()
    }
  }

  // Function to handle back button from trait detail to trait list
  const handleBackToTraitList = () => {
    setModalView('traitList');
  }

  // Function to close the modal completely
  const handleCloseModal = () => {
    setModalView(null);
  }

  if (runData?.status !== 'Completed') {
    return (
      <>
        <PRSNotCompleted runData={runData} />
      </>
    )
  }

  if (isLoading) {
    return (
      <div className='text-center'>
        <Loader />
      </div>
    )
  }
  if (error) {
    return <div></div>
  }
  const runsBreadCrumbs = [
    {
      title: 'Back',
      path: '/prs-runs',
      isSeparator: false,
      isActive: true,
    },
  ]

  return (
    <>
      <PageTitle back='runs' breadcrumbs={runsBreadCrumbs}>
        {intl.formatMessage({ id: 'RUN.DETAIL' })}
      </PageTitle>
  
      <div className='row'>
        {/* LEFT: ChatBox */}
        <div className='col-lg-8 col-md-6 col-sm-12 order-2 order-md-1'>
          <div className='pt-2 pb-4 prsRunDetail h-100'>
 
            <ChatBox
              runId={id}
              nodeId={runData.onNode}
              productId={runData.productItems[0].id}
            />
          </div>
        </div>
  
        {/* RIGHT: ReportButtons + Small Info Boxes */}
        <div className='col-lg-4 col-md-6 col-sm-12 order-1 order-md-2'>
          <div className='my-2 prsRunDetail'>
            {/* ReportButtons: tam genişlik */}
            <div className='mb-3'>
              <ReportButtons
                onSearchClick={handleSearchPreset}
                onReportClick={handleReportPreset}
                presets={presets}
              />
            </div>
            
            {/* Client Info Accordion Item */}
            <ClientInformation client={runData.productItems[0].client} />

            <div className='accordion rounded shadow-sm' id='infoAccordion'>
              {/* PRS Info Accordion Item */}
              <div className='accordion-item'>
                <h2 className='accordion-header prs-info-heading' id='prsInfoHeading'>
                  <button
                    className='accordion-button collapsed'
                    type='button'
                    data-bs-toggle='collapse'
                    data-bs-target='#prsInfo'
                    aria-expanded='false'
                    aria-controls='prsInfo'
                  >
                    PRS Information
                  </button>
                </h2>
                <div
                  id='prsInfo'
                  className='accordion-collapse collapse'
                  aria-labelledby='prsInfoHeading'
                  data-bs-parent='#infoAccordion'
                >
                  <div className='accordion-body'>
                    <PrsInformation
                      genomeBuild={runData.genomeBuild}
                      productItem={runData.productItems[0]}
                    />
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
  
        {/* Modal Area - Unified approach */}
        {modalView && (
          <div className="modal fade show d-block" style={{backgroundColor: `rgba(0, 0, 0, 0.5)`}} tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-xl modal-dialog-centered" role="document">
              <div className="modal-content">
                {modalView === 'traitList' && (
                  <TraidList
                    runTraits={runTraits.traits}
                    selectedPreset={selectedPreset}
                    getAvailableTraits={getAvailableTraits}
                    selectedTraidList={selectedTraidList}
                    selectedPresetChangeLoading={selectedPresetChangeLoading}
                    setSelectedTraidList={setSelectedTraidList}
                    onTraitClick={handleTraitClick}
                    onClose={handleCloseModal}
                  />
                )}

                {modalView === 'traitDetail' && (
                  <TraitDetailModal
                    selectedPgsData={selectedPgsData}
                    isModalOpen={true}
                    handleNext={handleNext}
                    handlePrevious={handlePrevious}
                    availableTraits={availableTraits}
                    onClose={() => setModalView('traitList')} // Go back to trait list when closing
                  />
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export { PrsRunDetailPage }